class TasteSelector extends HTMLElement {
  constructor() {
    super();

    this.handleClick = this.onClick.bind(this);
  }

  get sectionId() {
    return this.dataset.sectionId || null;
  }

  get sectionById() {
    return document.getElementById(`shopify-section-${this.sectionId}`) || null;
  }

  get tasteLabels() {
    return this.querySelectorAll('[data-taste-label]');
  }

  connectedCallback() {
    this.tasteLabels.forEach(label => {
      if (label.hasAttribute('data-taste-product'))
        label.addEventListener('click', this.handleClick);
    })
  }

  disconnectedCallback() {
    this.tasteLabels.forEach((label) => {
      label.removeEventListener('click', this.handleClick);
    });
  }

  async onClick(event) {
    const clickedTaste = event.target.closest('[data-taste-product]');
    const productUrl = clickedTaste?.dataset.tasteProduct;
    if (!productUrl) return;

    await this.renderProduct(productUrl);
  }

  async renderProduct(productUrl) {
    const currentSection = this.sectionById;
    if (!currentSection) return;

    const selectedOptions = Array.from(
      currentSection.querySelectorAll('variant-selects fieldset input:checked, variant-selects li[data-variant][data-selected]')
    ).map((element) => {
      const isInput = element.matches('input');

      return {
        name: isInput ? element.name?.trim() : element.dataset.optionName?.trim(),
        value: isInput ? element.value?.trim() : element.dataset.optionValue?.trim(),
      };
    });

    const oldPlan = currentSection.querySelector('.buy-option.checked');
    const oldPlanText = currentSection
      .querySelector('subscription-widget-redesign select option:checked')
      ?.textContent
      .trim();

    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', this.sectionId);

    const response = await fetch(url.toString());
    const html = await response.text();

    const nextDocument = new DOMParser().parseFromString(html, 'text/html');
    const nextSection = nextDocument.getElementById(`shopify-section-${this.sectionId}`);

    if (!nextSection) return;

    selectedOptions.forEach((selectedOption) => {
      const nextInput = Array.from(
        nextSection.querySelectorAll('variant-selects fieldset input[type="radio"], li[data-variant]')
      ).find((element) => {
        const isInput = element.matches('input');
        const value = isInput ? element.value?.trim() : element.dataset.optionValue?.trim();

        return value === selectedOption.value;
      });
      if (!nextInput) return;
      if (nextInput.matches('li[data-variant]')) {
        const dropdown = nextInput.closest('size-dropdown');
        if (!dropdown?.dataset.targetSelect) return;

        const nativeSelect = nextSection.querySelector(`#${dropdown.dataset.targetSelect}`);
        if (!nativeSelect) return;

        dropdown.querySelector('[data-selected]')?.removeAttribute('data-selected');
        nextInput.setAttribute('data-selected', '');

        nativeSelect.value = nextInput.dataset.optionValue;
      } else {
        nextInput.checked = true;
      }
    });

    if (oldPlanText) {
      const nextPlanSelect = nextSection.querySelector('subscription-widget-redesign select');
      const nextPlanOption = Array.from(nextPlanSelect?.options || []).find(
        (option) => option.textContent.trim() === oldPlanText
      );

      if (nextPlanOption) {
        nextPlanSelect.value = nextPlanOption.value;
      }
    }

    const nextOnetime = nextSection.querySelector('[onetime]');
    const nextSubscription = nextSection.querySelector('[subscription]');

    if (oldPlan?.hasAttribute('onetime')) {
      nextOnetime?.classList.add('checked');
      nextSubscription?.classList.remove('checked');
    } else {
      nextOnetime?.classList.remove('checked');
      nextSubscription?.classList.add('checked');
    }

    currentSection.replaceWith(nextSection);

    if (this.hasAttribute('data-shared-flavor')) {
      nextSection.dispatchEvent(new CustomEvent('product:flavor-change', {
        bubbles: true,
        detail: { productUrl },
      }));
    }

    const changedInputs = selectedOptions
      .map((selectedOption) => {
        const radio = nextSection.querySelector(
          `variant-selects fieldset input[type="radio"][value="${selectedOption.value}"]`
        );

        if (radio) return radio;

        return Array.from(nextSection.querySelectorAll('variant-selects select')).find(
          (select) => select.value === selectedOption.value
        );
      })
      .filter(Boolean);

    changedInputs.forEach((input) => {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    nextSection
      .querySelector('subscription-widget-redesign select')
      ?.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('taste-selector')) {
  customElements.define('taste-selector', TasteSelector);
}